<template>
  <div :class="classes">
    <div class="content-popup__content">
      <slot name="content">Default content</slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'content-popup',
    props: {
      position: {
        type: String,
        default: 'center',
      },
    },
    computed: {
      classes() {
        let result = ['content-popup']
        if (this.position !== 'center') {
          result.push(`content-popup--${this.position}`)
        }
        return result.join(' ')
      },
    },
  }
</script>

<style lang="scss">
  .content-popup {
    position: absolute;
    top: 50%;
    transition: $transition-base;
    left: 50%;
    right: 50%;
    max-width: 28rem;
    width: 85%;
    z-index: 10;
    transform: translate(-50%, -50%);
    box-shadow: 2px 2px 9px rgba(0, 0, 0, 0.2);
    padding: spacer(1) spacer(3) spacer(1) spacer(2);
    border-left: 4px solid $community;
    background: $white;

    @media (min-width: $bp-sm) {
      padding: spacer(2) spacer(4) spacer(2) spacer(3);
    }

    &--top {
      top: 10%;
      transform: translate(-50%, 0);
    }

    &--visible {
      transform: translate(-50%, -50%);
      bottom: spacer(1);

      @media (min-width: $bp-sm) {
        bottom: spacer(4);
      }
    }

    &__content {
      font-weight: bold;

      @media (min-width: $bp-sm) {
        font-size: $font-size-md;
      }
    }
  }
</style>
